import { useNavigate } from "react-router-dom";
import Header from "@/components/Header";
import PayoutsPanel from "@/components/PayoutsPanel";

/** Where Stripe returns the cleaner after Express onboarding. Returning here proves nothing —
 *  PayoutsPanel re-checks the real status with Stripe before showing "Payouts active". */
export default function PayoutsReturn() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-background">
      <Header />
      <div className="max-w-2xl mx-auto px-5 sm:px-8 py-12" data-testid="payouts-return">
        <h1 className="font-display text-3xl font-semibold tracking-tight mb-2">Payout setup</h1>
        <p className="text-muted-foreground mb-6">
          We've checked your details with Stripe. If anything is still outstanding you can finish it
          below.
        </p>
        <PayoutsPanel />
        <button onClick={() => navigate("/cleaner/dashboard")}
          className="mt-6 px-6 py-3 rounded-full border border-border font-medium hover:bg-secondary transition-colors"
          data-testid="payouts-return-dashboard">Back to my dashboard</button>
      </div>
    </div>
  );
}
